'use client';

import { c as _c } from "react/compiler-runtime";
import { Collapsible, CollapsibleContent, CollapsibleTrigger, SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem } from '@repo/ui/components';
import { ChevronRight } from '@repo/ui/icons';
import { usePathname } from 'next/navigation';
import { PrefetchLink } from '@/app/@protected/_components/prefetch-link.tsx';
import { SidebarItem } from '@/app/@protected/_components/sidebar/sidebar-content.tsx';
export const CollapsibleMenu = item => {
  const $ = _c(31);
  const path = usePathname();
  let t0;
  if ($[0] !== item.groupUrl || $[1] !== item.url || $[2] !== path) {
    t0 = path === item.url || path.startsWith(`${item.groupUrl}`);
    $[0] = item.groupUrl;
    $[1] = item.url;
    $[2] = path;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const isActive = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SidebarMenuItem className="group/collapsible" />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isActive) {
    t2 = e => {
      if (isActive) {
        e.preventDefault();
      }
    };
    $[5] = isActive;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== item.url || $[8] !== t2) {
    t3 = <PrefetchLink href={item.url} onNavigate={t2} />;
    $[7] = item.url;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== item.title || $[11] !== t3) {
    t4 = <SidebarMenuButton render={t3} tooltip={item.title} />;
    $[10] = item.title;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== item.icon) {
    t5 = item.icon && <item.icon />;
    $[13] = item.icon;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== item.title) {
    t6 = <span>{item.title}</span>;
    $[15] = item.title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronRight className="ml-auto transition-transform duration-200 group-data-panel-open/collapsible:rotate-90" data-sentry-element="ChevronRight" data-sentry-source-file="collapsible-menu.tsx" />;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t8 = <CollapsibleTrigger nativeButton={false} render={t4} data-sentry-element="CollapsibleTrigger" data-sentry-source-file="collapsible-menu.tsx">{t5}{t6}{t7}</CollapsibleTrigger>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== item.items || $[23] !== path) {
    t9 = item.items?.map(subItem => <SidebarMenuSubItem key={subItem.title}><SidebarMenuSubButton isActive={path === subItem.url} render={<PrefetchLink href={subItem.url} />}><span>{subItem.title}</span></SidebarMenuSubButton></SidebarMenuSubItem>);
    $[22] = item.items;
    $[23] = path;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t9) {
    t10 = <CollapsibleContent data-sentry-element="CollapsibleContent" data-sentry-source-file="collapsible-menu.tsx"><SidebarMenuSub data-sentry-element="SidebarMenuSub" data-sentry-source-file="collapsible-menu.tsx">{t9}</SidebarMenuSub></CollapsibleContent>;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== isActive || $[28] !== t10 || $[29] !== t8) {
    t11 = <Collapsible defaultOpen={isActive} render={t1} data-sentry-element="Collapsible" data-sentry-component="CollapsibleMenu" data-sentry-source-file="collapsible-menu.tsx">{t8}{t10}</Collapsible>;
    $[27] = isActive;
    $[28] = t10;
    $[29] = t8;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};